module.exports = __webpack_public_path__ + "static/media/logo-3.53d5b116.png";